import React, { Suspense, useEffect, useRef, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import OldRoutes from "./routes/OldRoutes";
import { Loading } from "../pages/Loading";
import NewRoutes from "./routes/NewRoutes";
import ProtectedRoute from "./ProtectedRoute";
import AdminRoutes from "./routes/AdminRoutes";

const Login = React.lazy(() => import("../pages/Login"));
const Redirect = React.lazy(() => import("../pages/Redirect"));

const NotFound = React.lazy(() => import("../pages/NotFound"));

type RoutesManagerProps = {
  navigateWorkspace: (...args: any[]) => void;
  actualpage?: any;
  userData?: any;
  orgData?: any;
  handleLoginAs?: (...args: any[]) => void;
  handleLogout?: (...args: any[]) => void;
  handleClickVariant: (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => void;
  setShowProtocole?: (page: number) => void; // Optional prop to control protocol visibility
};

const RoutesManager: React.FC<RoutesManagerProps> = ({
  navigateWorkspace,
  actualpage,
  userData,
  orgData,

  handleLoginAs,

  handleLogout,
  handleClickVariant,
  setShowProtocole,
}) => {
  return (
    <div className="pointer-events-auto h-full w-full overflow-auto">
      <Routes>
        <Route path="/" element={<Redirect />} />
        <Route
          path="/login"
          element={
            <Login
              userData={userData}
              navigateWorkspace={navigateWorkspace}
              handleLogout={handleLogout}
            />
          }
        />

        <Route
          path="/*"
          element={
            <OldRoutes
              navigateWorkspace={navigateWorkspace}
              actualpage={actualpage}
              userData={userData}
              orgData={orgData}
              handleLoginAs={handleLoginAs}
              handleClickVariant={handleClickVariant}
              setShowProtocole={setShowProtocole}
            ></OldRoutes>
          }
        />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute
              requiredRole={"admin"}
              navigateWorkspace={navigateWorkspace}
            >
              <AdminRoutes
                navigateWorkspace={navigateWorkspace}
                handleLoginAs={handleLoginAs}
                userData={userData}
                orgData={orgData}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={<NotFound navigateWorkspace={navigateWorkspace} />}
        />
      </Routes>
    </div>
  );
};

export default RoutesManager;
